import * as Yup from 'yup'

const ratingFormValue = {
  value: 0,
  comment: ''
}

export const clientInitialValues = {
  overallRate: ratingFormValue,
  contactRate: ratingFormValue,
  deliveryRate: ratingFormValue
}

export const forwarderInitialValues = {
  clientRate: ratingFormValue,
  carrierRate: ratingFormValue,
  driverRate: ratingFormValue
}

function orderRatingFieldOption (name) {
  return {
    name: name,
    label: `orderRatingView.ratings.${name}`
  }
}

export const orderRatingByClientFieldOptions =
  [
    orderRatingFieldOption('overallRate'),
    orderRatingFieldOption('contactRate'),
    orderRatingFieldOption('deliveryRate')
  ]

export const orderRatingByForwarderFieldOptions =
  [
    orderRatingFieldOption('clientRate'),
    orderRatingFieldOption('carrierRate'),
    orderRatingFieldOption('driverRate')
  ]

const orderRatingSchema = Yup.object().shape({
  value: Yup.number()
    .required('form.validation.required')
    .min(1)
    .max(5),
  comment: Yup.string().when('value', {
    is: (value) => value < 3,
    then: Yup.string().required('form.validation.required'),
    otherwise: Yup.string()
  })
})

export const orderRatingByClientSchema = Yup.object().shape({
  overallRate: orderRatingSchema,
  contactRate: orderRatingSchema,
  deliveryRate: orderRatingSchema,
})

export const orderRatingByForwarderSchema = Yup.object().shape({
  clientRate: orderRatingSchema,
  carrierRate: orderRatingSchema,
  driverRate: orderRatingSchema,
})
